import { Configuration } from "@azure/msal-browser";

const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CONFIG_CLIENT_ID ?? "",
        redirectUri: (process.env.REACT_APP_APP_URL ?? "") + "/login",
        authority: "https://login.microsoftonline.com/common",
    },
    cache: {
        cacheLocation: "session",
    },
};

export default msalConfig;
